import { Cloud, ShoppingCart, Users, Building2, Code2, FileText } from 'lucide-react';
import ScrollReveal from './ScrollReveal';

const useCases = [
  {
    icon: Cloud,
    title: 'SaaS Platforms',
    benefit: 'Ensure your app pages, docs, and pricing are fully indexable — even behind heavy JavaScript frameworks.',
  },
  {
    icon: ShoppingCart,
    title: 'E-commerce',
    benefit: 'Get every product page discovered and ranked. Fix faceted navigation, dynamic filters, and JS-loaded catalogs.',
  },
  {
    icon: Users,
    title: 'Digital Agencies',
    benefit: 'Run domain-wide audits for every client, share master reports in reviews, and standardize optimization playbooks.',
  },
  {
    icon: Building2,
    title: 'Enterprise',
    benefit: 'Govern large website portfolios with grouped sampling, async background processing, and executive-ready master reports.',
  },
  {
    icon: Code2,
    title: 'JS Frameworks',
    benefit: 'React, Angular, Vue, Next.js — verify that server-side rendering or pre-rendering is actually working.',
  },
  {
    icon: FileText,
    title: 'Content Platforms',
    benefit: 'Make sure your articles, blogs, and knowledge bases are discoverable by both search engines and AI assistants.',
  },
];

const UseCaseGrid = () => (
  <section className="py-20 md:py-24 bg-white">
    <div className="max-w-6xl mx-auto px-4 sm:px-6">
      <ScrollReveal>
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 bg-cv-sky/10 text-cv-navy text-xs font-bold uppercase tracking-wider rounded-full border border-cv-sky/30 mb-4">
            Use Cases
          </span>
          <h2 className="text-3xl sm:text-4xl font-extrabold text-cv-navy mb-4">
            Built for Teams That Depend on <span className="text-cv-navy">Visibility</span>
          </h2>
          <p className="text-cv-navy/70 max-w-2xl mx-auto text-lg">
            Whether you're a solo developer or a global enterprise, Crawler Vision helps you stay visible where it matters.
          </p>
        </div>
      </ScrollReveal>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {useCases.map((uc, i) => (
          <ScrollReveal key={uc.title} delay={i * 0.08}>
            <div className="bg-cv-navy/5 rounded-2xl border border-cv-navy/10 p-6 h-full hover:shadow-lg hover:border-cv-sky/30 transition-all group">
              <div className="w-11 h-11 rounded-xl bg-cv-navy flex items-center justify-center mb-4 group-hover:scale-110 transition-transform shadow-sm">
                <uc.icon className="w-5 h-5 text-white" />
              </div>
              <h3 className="text-base font-bold text-cv-navy mb-2">{uc.title}</h3>
              <p className="text-sm text-cv-navy/70 leading-relaxed">{uc.benefit}</p>
            </div>
          </ScrollReveal>
        ))}
      </div>
    </div>
  </section>
);

export default UseCaseGrid;
